<template>
  <v-autocomplete
    v-model="model"
    :items="entries"
    :loading="isLoading"
    :search-input.sync="search"
    :item-text="textItem"
    :item-value="valueItem"
    persistent-hint
    clearable
    :ttype="isInn ? 'number' : 'string'"
    :label="title"
    :placeholder="placeholder"
    @change="onChangeSearch"
    @focus="onFocus"
    @blur="onBlur"
    :hint="
      model
        ? isInn
          ? `${model.value}`
          : `${$t('components.lib.physicalSearch.inn')}: ${model.inn}`
        : ''
    "
    ref="autocomplete"
    :reradonly="model ? true : false"
    :required="required"
    :rules="dRule"
  >
    <template v-slot:append-item>
      <v-btn block @click.stop="onAddNewPhysical"
        >{{ $t('components.lib.physicalSearch.addNew') }}</v-btn
      >
    </template>
    <template v-slot:item="data">
      <v-list-item-content>
        <v-list-item-title v-html="data.item.value"></v-list-item-title>
        <v-list-item-subtitle v-html="data.item.inn"></v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import { apiCallTrue } from "@/utils/api";
import showNotify from "@/services/noty";
import axios from "axios";
import rules from "@/utils/data/rules";
import i18n from "@/services/i18n";

export default {
  name: "PhysicalSearch",
  props: {
    isInn: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: i18n.t("components.lib.physicalSearch.title"),
    },
    placeholder: {
      type: String,
      default: i18n.t("components.lib.physicalSearch.placeholder"),
    },
    onChangeCallback: Function,
  },
  data: () => ({
    descriptionLimit: 60,
    entries: [],
    isLoading: false,
    model: null,
    search: null,
    cancelToken: null,
    forceFirstSelected: false,
    rules,
  }),
  computed: {
    isModel() {
      if (!this.model) return false;
      return true;
    },

    dRule() {
      //if(this.isInn)
      //return this.rules.inn;
      return this.rules.rule;
    },
  },
  mounted() {},
  methods: {
    textItem: (item) => item.value, // + " — " + item.inn,
    valueItem: (item) => item,

    onAddNewPhysical() {
      console.log("ON CLICK ");
      this.$router.push({ name: "AddPhysics" });
    },

    onFocus() {
      this.getCompanyAPI(this.$refs.autocomplete.internalSearch, false);
    },
    onBlur() {
      console.log("ONB", this.model);
      if (!this.isModel) {
        this.model = null;
        this.entries = [];
        this.$refs.autocomplete.internalSearch = null;
        if (this.onChangeCallback) this.onChangeCallback(null);
      }
    },
    onChangeSearch(a) {
      this.$refs.autocomplete.internalSearch = a
        ? this.isInn
          ? a.inn
          : a.value
        : null;
      if (this.onChangeCallback) this.onChangeCallback(a);
      console.log("CHA", a, this.model);
    },
    async getCompanyAPI(search) {
      if (search) {
        search = "/" + search;
      } else {
        search = "";
      }
      if (this.cancelToken) {
        this.cancelToken.cancel("Отмена предыдущего ajax запроса");
      }

      // if (!search && checkEmpty) return;
      this.entries = [];
      const CancelToken = axios.CancelToken;
      this.cancelToken = CancelToken.source();

      this.isLoading = true;
      await apiCallTrue({
        url: `v1/autocomplete/physical-search${search}`,
        cancelToken: this.cancelToken.token,
      })
        .then((response) => {
          if (response.data && response.data) {
            this.entries = response.data.data;
            if (
              this.entries &&
              this.entries.length > 0 &&
              this.forceFirstSelected
            ) {
              this.model = this.entries[0];
              if (this.model) {
                this.onChangeSearch(this.model);
              }
            }
          }
          this.forceFirstSelected = false;
        })
        .catch((error) => {
          showNotify("error", error);
        })
        .finally(() => {
          this.cancelToken = null;
          this.isLoading = false;
        });
    },
  },
  watch: {
    // search(val) {
    //   console.log("SEARRCH", val);
    //   // if (this.isLoading) return;
    //   if (this.model) {
    //     let paramValue = this.isInn ? "inn" : "value";
    //     if (this.model[paramValue] != val) this.model = null;
    //   }
    //   if (!this.onceWatchApiContinue) this.getCompanyAPI(val);
    //   else this.onceWatchApiContinue = false;
    // },
  },
};
</script>
